export default __webpack_public_path__ + "static/media/logo-vertical.319d9b94.svg";